/**
 * @description 导出网络配置
 **/

let baseURL = {
  Gateway: 'https://gateway-staging.tengyuone.com:9443/',
  FileHost: 'https://file.tengyuone.com/',
  H5Host: 'https://wx-staging.tengyuone.com/',
}

// prod
// baseURL = {
//   Gateway: 'http://gateway.tengyucloud.com/',
//   FileHost: 'http://file.tengyucloud.com/',
//   H5Host: 'http://wx.tengyuone.com/',
// }

module.exports = {
  // 默认的接口地址，开发环境和生产环境都会走/vab-mock-server
  // 正式项目可以选择自己配置成需要的接口地址，如"https://api.xxx.com"
  // 问号后边代表开发环境，冒号后边代表生产环境
  baseURL: baseURL,
  // 配后端数据的接收方式application/json;charset=UTF-8 或 application/x-www-form-urlencoded;charset=UTF-8
  contentType: 'application/json;charset=UTF-8',
  // 最长请求时间
  requestTimeout: 10000,
  // 操作正常code，支持String、Array、int多种类型
  successCode: [200, 0, '200', '0'],
  // 数据状态的字段名称
  statusName: 'Code',
  // 状态信息的字段名称
  messageName: 'Message',
}
